import { useContext, useMemo } from 'react'

import { ActiveTenantContext, ActiveUserContext } from '../../context/common/Context'


export const useActiveTenant = () => {
  const { tenantId, setTenantId } = useContext(ActiveTenantContext)
  const { user } = useContext(ActiveUserContext)

  const tenant = useMemo(() => {
    if (!tenantId || !user) return undefined
    return user.tenants.find((t) => t.tenantId === tenantId)
  }, [tenantId, user])

  return { tenant, setTenantId }
}
